import useGetInternalWidgetConfig from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import { useCurrentTrackerDeviceContext } from '@hooks/useCurrentTrackerDevice';
import QueryKeys from '@src/constants/queryKeys';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { useMemo } from 'react';
import DeviceDataTable from '../DeviceDataTable/DeviceDataTable';
import { trackerSx } from '../sxStyles/Datatable/deviceTableList';
import UIBox from '../UIBox';

export default function TrackerList() {
  const { currentTrackerDevice } = useCurrentTrackerDeviceContext();
  const { deviceId: currentTrackerId } = currentTrackerDevice || {
    deviceId: 'master_tracker_1',
  };

  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useGetInternalWidgetConfig<WidgetTypeDeviceList>(
    `trackerList`,
    {
      sourceDeviceId: currentTrackerId,
    },
    {
      queryKeys: [QueryKeys.trackers, currentTrackerId],
      enabled: currentTrackerId !== undefined,
    },
  );

  const memoizedDevices = useMemo(
    () => widgetConfig?.devices || [],
    [widgetConfig?.devices],
  );

  const memoizedDataPoints = useMemo(
    () => widgetConfig?.dataPoints || [],
    [widgetConfig?.dataPoints],
  );

  const memoizedPointConfigRefs = useMemo(
    () => widgetConfig?.pointConfigRefs || [],
    [widgetConfig?.pointConfigRefs],
  );

  return (
    <UIBox
      header={widgetConfig?.header}
      subheader={currentTrackerDevice?.name}
      isLoading={isLoading}
      isError={isError || (!widgetConfig && !isLoading)}
      sx={{
        flex: 1,
        boxShadow: 'none',
      }}
    >
      <DeviceDataTable
        widgetId='trackers'
        additionalClassnames='detail-data-table'
        hideFooter
        devices={memoizedDevices}
        dataPoints={memoizedDataPoints}
        pointConfigRefs={memoizedPointConfigRefs}
        useDualListView={widgetConfig?.useDualListView ?? false}
        sx={trackerSx.detailDataTable}
      />
    </UIBox>
  );
}
